import React from 'react';
import LoaderImage from '../../assets/Icons/loader.svg';
import '../../assets/scss/general.scss';

export default function Loader() {
  return (
    <div className="loading">
      <span><img src={LoaderImage} alt="Logo" /></span>
      <span><img src={LoaderImage} alt="Logo" /></span>
      <span><img src={LoaderImage} alt="Logo" /></span>
      <span><img src={LoaderImage} alt="Logo" /></span>
      <span><img src={LoaderImage} alt="Logo" /></span>
    </div>
  )
}
